import { action } from 'mobx'
import { task } from 'mobx-task'
import { ModalViewModel } from '@/infra/ModalViewModel'

export interface ConnectWithProDialogViewModelOptions {
  onConfirm: () => Promise<void>
}

export class ConnectWithProDialogViewModel {
  readonly modal = new ModalViewModel()

  constructor(
    private readonly _options: ConnectWithProDialogViewModelOptions,
  ) {}

  @action.bound
  showDialog() {
    this.modal.show()
  }

  @action.bound
  closeDialog() {
    this.modal.close()
  }

  confirm = task.resolved(async () => {
    await this._options.onConfirm()
    this.closeDialog()
  })
}
